import React, { useState } from "react";
import TextInput from "../../../../components/TextInput";
import { toast } from "../../../../components/toastNotification";
import Button from "../../../../components/Button";
import { CheckCircleIcon, XCircleIcon } from "@heroicons/react/24/solid";
import ConfirmBoxModal from "../../../../components/ConfirmBoxModal";
import useAddEmploymentType from "./hooks/useAddEmploymentType";
import useEmploymentType from "./hooks/useEmploymentType";
import { useRecoilState, useRecoilValue } from "recoil";
import { accountAtom } from "../../../Login/atoms/AccountAtom";
import MaterialExTable from "../../../../components/tables/MaterialExTable";

import {
  addStateEmployementType,
  setFilterTextEmploymentType,
} from "./atoms/atoms";

import CheckBoxHookForm from "components/CheckBoxHookForm";

const EmploymentTypeForm = () => {
  //Hooks
  const AddEmploymentType = useAddEmploymentType();
  const { data } = useEmploymentType();
  //Recoils Call
  const [actionAddState, setActionAddState] = useRecoilState(
    addStateEmployementType
  );
  const [_, setFilterText] = useRecoilState(
    setFilterTextEmploymentType
  );
  const userAccount = useRecoilValue(accountAtom);
  //Local States
  const [changed, setChanged] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [hasEmploymentType, setHasEmploymentType] = useState(false);
  const [employmentTypeExist, setEmploymentTypeExist] = useState(false);

  const defaulValues = {
    employmentTypeId: 0,
    employmentTypeName: "",
    createdBy: "",
    createdDate: null,
    modifiedBy: null,
    modifiedDate: null,
    isActive: 0,
    usedInMexico: 0,
  };
  const [empTypeNewData] = useState([defaulValues]);

  const handleAddEmploymentType = (SourceType, fieldName, inputValue, rowData) => {
    if (SourceType !== "addEmploymentType") return;

    setChanged(true);
    setEmploymentTypeExist(false);

    if (fieldName === "employmentTypeName") {
      const trimmedInput = inputValue.trim().toUpperCase();
      const nameMatch = data.find(
        (item) =>
          item.employmentTypeName?.toUpperCase() === trimmedInput &&
          item.usedInMexico === rowData?.usedInMexico
      );

      if (nameMatch) {
        setEmploymentTypeExist(true);
      } else {
        empTypeNewData.forEach((x) => {
          x.employmentTypeName = inputValue.trim();
        });
      }

      setHasEmploymentType(trimmedInput !== "");
    }

    if (fieldName === "employmentTypeIsMexico") {
      const existingEntry = data.find(
        (item) =>
          item.employmentTypeName?.toUpperCase() ===
          rowData?.employmentTypeName?.trim().toUpperCase() &&
          item.usedInMexico === inputValue
      );

      if (existingEntry) {
        setEmploymentTypeExist(true);
      }

      empTypeNewData.forEach((x) => {
        x.usedInMexico = inputValue;
      });
    }
  };


  //save changes
  const handleSave = (empTypeNewData) => {
    if (changed) {
      if (!employmentTypeExist) {
        if (empTypeNewData.filter((x) => x.employmentTypeName) !== "") {
          //call Insert
          AddEmploymentType(empTypeNewData);
          setActionAddState(!actionAddState);
          setOpenModal(false);
        } else {
          toast.fire(
            "Saving Failed",
            "All required fields must be filled!",
            "error"
          );
          setOpenModal(false);
        }
      } else {
        toast.fire("Saving Failed", "Employment Type already exists!", "error");
        setOpenModal(false);
      }
    } else {
      toast.fire("Saving Failed", "No Changes have been made", "warning");
      setOpenModal(false);
    }
  };
  // end of saving changes

  const matcolumns = [
    {
      title: "Employment Type Name",
      field: "employmentTypeName",
      render: (rowData) => {
        return (
          <div className="grid-cols-2 grid ">
            <div className="">
              <TextInput
                defaultValue={rowData.employmentTypeName}
                onChange={(e) => {
                  handleAddEmploymentType(
                    "addEmploymentType",
                    "employmentTypeName",
                    e.target.value.trim()
                  );

                  e.target.value = e.target.value.replace(/\s+/g, " ");
                }}
              />
            </div>
          </div>
        );
      },
    },
    {
      title: "Is Mexico",
      render: (rowData) => {
        return (
          <CheckBoxHookForm
            checked={rowData.usedInMexico === true ? true : false}
            onClick={(e) => {
              handleAddEmploymentType(
                "addEmploymentType",
                "employmentTypeIsMexico",
                !rowData.usedInMexico,
                rowData
              )
            }}
            register={() => { }}
          />
        )
      }
    },
  ];
  return (
    <div className="">
      <div className="w-full ">
        <ConfirmBoxModal
          ModalTitle="Add Employment Type"
          qConfirmation=" Are you sure you want to add this?"
          isOpen={openModal}
          onClose={() => setOpenModal(false)}
          onClickFunction={() => {
            handleSave(empTypeNewData);
          }}
        />
        <div className=" px-3 border-l-2  border-primary box-shadow">
          <div className="flex items-center justify-between">
            <div className="text-base text-primary font-bold">
              Add New Employment Type
            </div>
            <div className="flex items-center space-x-2 pt-2 pb-2">
              <Button
                className={`flex items-center shadow-md text-xs font-semibold text-white justify-left gap-x-1 rounded-full bg-senary hover:bg-senary px-3 py-1 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-senary focus:ring-opacity-70
              ${!hasEmploymentType ? "opacity-50" : "opactiy-100"}`}
                disabled={!hasEmploymentType}
                onClickFunction={() => setOpenModal(true)}
              >
                <CheckCircleIcon className="h-4 w-4" />
                <div className="text-xs3 font-normal self-center -mt-px">
                  Save
                </div>
              </Button>
              <Button
                className="flex items-center text-xs shadow-md font-semibold text-white justify-left gap-x-1 rounded-full bg-octonary hover:bg-octonary px-2 py-1 "
                onClickFunction={() => {
                  setActionAddState(!actionAddState);
                  setFilterText("");
                }}
              >
                <XCircleIcon className="h-4 w-4" />
                <div className="text-xs3 font-normal self-center -mt-px">
                  Cancel
                </div>
              </Button>
            </div>
          </div>

          <div className="h-0.5 w-full border-b-2 border-secondary "></div>

          {/* <div className="py-3"></div> */}

          <div className=" w-full py-2 ">
            <MaterialExTable
              columns={matcolumns}
              data={empTypeNewData}
              paging={false}
            />
          </div>
        </div>
        <div className="hidden sm:block" aria-hidden="true">
          <div className="py-1"></div>
        </div>
      </div>
    </div>
  );
};

export default EmploymentTypeForm;
